import React from "react";
import {
  Box,
  Container,
  Typography,
  Breadcrumbs,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PageHeaderWithBreadcrumbs = ({
  breadcrumbs,
  title,
  applyButtonText,
  applyButtonLink = "/contact",
  backgroundColor = "#E8EDF6",
  sticky = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      data-sticky-header
      sx={{
        position: isMobile ? "static" : sticky ? "sticky" : "static",
        top: isMobile ? undefined : 80,
        zIndex: isMobile ? undefined : 100,
        backgroundColor: "white",
      }}
    >
      {/* Breadcrumbs */}
      <Box sx={{ backgroundColor, py: { xs: 1, md: 2 } }}>
        <Container maxWidth="lg">
          <Breadcrumbs
            separator={<NavigateNext fontSize="small" />}
            aria-label="breadcrumb"
            // sx={{ fontSize: "0.9rem" }}
          >
            {breadcrumbs.map((item, idx) =>
              idx === breadcrumbs.length - 1 ? (
                <Box
                  key={idx}
                  component="span"
                  color="text.primary"
                  aria-current="page"
                  sx={{ fontWeight: 500, fontSize: "14px" }}
                >
                  {item.text}
                </Box>
              ) : (
                <RouterLink
                  key={idx}
                  to={item.href}
                  style={{
                    textDecoration: "none",
                    color: "#0C3058",
                    fontSize: "14px",
                    fontWeight: 300,
                    "&:hover": {
                      color: "#2e6cb4 !important",
                    },
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  {item.text}
                </RouterLink>
              )
            )}
          </Breadcrumbs>
        </Container>
      </Box>

      {/* Header avec titre et bouton */}
      <Box sx={{ backgroundColor, py: { xs: 3, md: 4 } }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: 600,
                color: "#0C3058",
                fontSize: { xs: "1.6rem", md: "1.6rem" },
              }}
            >
              {title}
            </Typography>
            {/* Bouton visible seulement sur desktop */}
            {!isMobile && applyButtonText && (
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: "#0C3058",
                  color: "white",
                  px: 4,
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#083046",
                  },
                }}
                onClick={() => navigate(applyButtonLink)}
              >
                {applyButtonText}
              </Button>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default PageHeaderWithBreadcrumbs;
